<template>
  <div id="app" ref="app">
    <!-- 导航 -->
    <PCNavbar/>
    <!-- <MobileNavBar/> -->
    <router-view></router-view>
    <CallMe/>
    <!-- <MobileCallme/> -->
<!--    <BackTop />-->
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  name: 'App',
  components: {
    PCNavbar,
    // MobileNavBar,
    CallMe,
    MobileCallme,
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
  created() {
    this.getCommon()
  },
  methods: {
     getCommon(){
      this.$request({
            url: 'common',
            method: 'get',
          }).then(res => {
            const {menu , company} = res.data
            this.$store.commit('setMenu', menu)
            this.$store.commit('setCompany', company)
          })
     }
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');

/*flex布局，元素垂直方向往中间挤*/
.flex{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
/*文字一行*/
.textOne{
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}
/*文字两行*/
.textTwo{
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
